module.exports = __webpack_public_path__ + "static/21-5e59b4113c70cf0769aac0a35da49452.png";